<div modalHeader class="modal-header py-2">
  <h2 class="mb-0">{{ title }} Resource</h2>
  <tr-icon [icon]="icon.cancel" classes="ml-auto py-1 px-2" (click)="cancel()"></tr-icon>
</div>

<form modalContent [formGroup]="resourceForm" *ngIf="resourceForm" class="tr-form-services pl-2 pr-2" novalidate>
  <div class="modal-body">
    <div class="row form-group">
      <div class="col-xs-12 col-sm-5">
        <label for="service-name" class="lead col-form-label">Name *</label>
        <p>The display name for this resource.</p>
      </div>
      <div class="col-xs-12 col-sm-7 mt-2">
        <div class="d-flex">
          <input
            type="text"
            class="form-control"
            id="service-name"
            formControlName="name"
            name="resourceName"
            placeholder="Enter name"
            [class.is-invalid]="nameControl.invalid && nameControl.touched"
          />
          <label for="service-name" class="col-form-label ml-2 danger">
            <em>{{ enabledControl.value ? "" : "Disabled" }}</em>
          </label>
        </div>
        <control-messages [control]="nameControl"></control-messages>
      </div>
    </div>

    <div class="row form-group">
      <div class="col-xs-12 col-sm-5">
        <label for="service-description" class="lead col-form-label">Description</label>
      </div>
      <div class="col-xs-12 col-sm-7 mt-2">
          <textarea
            rows="2"
            class="form-control minh-50"
            id="service-description"
            formControlName="description"
            name="resourceDescription"
            placeholder="Optional"
          ></textarea>
      </div>
    </div>

    <div class="row form-group" formGroupName="capacity">
      <div class="col-xs-12 col-sm-5">
        <label for="resource-capacity-min" class="lead col-form-label">Capacity</label>
        <p>The min and max number of people this resource can accommodate.</p>
      </div>
      <div class="col-xs-12 col-sm-7 mt-2">
        <div class="d-flex">
          <label for="resource-capacity-min" class="lead col-form-label mr-2">Min</label>
          <input
            type="number"
            class="form-control"
            id="resource-capacity-min"
            formControlName="min"
            name="resourceCapacityMin"
            [class.is-invalid]="capacityMinControl.invalid && capacityMinControl.touched"
          />
          <label for="resource-capacity-max" class="lead col-form-label mx-2">Max</label>
          <input
            type="number"
            class="form-control"
            id="resource-capacity-max"
            formControlName="max"
            name="resourceCapacityMax"
            [class.is-invalid]="capacityMaxControl.invalid && capacityMaxControl.touched"
          />
        </div>
      </div>
    </div>

    <div class="row form-group" formGroupName="availability">
      <div class="col-xs-12 col-sm-5">
        <label for="resource-availability-waitlist" class="col-form-label lead">Availability</label>
        <p>Make this resource available for walk-ins and/or bookings.</p>
      </div>
      <div class="col-xs-12 col-sm-7 mt-2">
        <div class="form-check">
          <label class="form-check-label">
            <input
              type="checkbox"
              class="form-check-input"
              id="resource-availability-waitlist"
              name="availableWaitlist"
              formControlName="waitlist"
            > Public Check-In
          </label>
        </div>
        <div class="form-check">
          <label class="form-check-label">
            <input
              type="checkbox"
              class="form-check-input"
              id="resource-availability-reservations"
              name="availableReservations"
              formControlName="reservations"
            > Reservations/Appointments
          </label>
        </div>
      </div>
    </div>

    <div class="row form-group" *ngIf="services.length">
      <div class="col-xs-12 col-sm-5">
        <label class="col-form-label lead">Services</label>
      </div>
      <div class="col-xs-12 col-sm-7 mt-2">
        <frontend-dropdown
          class="w-100"
          elementId="resource-availability-services"
          [items]="services"
          bindLabel="name"
          bindValue="_id"
          [multiple]="true"
          formControlName="services"
          placeholder="Select services"
          [clearable]="true"
        ></frontend-dropdown>
      </div>
    </div>

    <div class="row form-group">
      <div class="col-xs-12 col-sm-5">
        <label class="col-form-label lead">Category</label>
        <p>Used for grouping resources in the display when not using floor plans.</p>
      </div>
      <div class="col-xs-12 col-sm-7 mt-2">
        <frontend-dropdown-plain
          class="w-100"
          elementId="category-dropdown"
          [items]="categories"
          [addTag]="true"
          [clearable]="true"
          formControlName="category"
          placeholder="Select category"
        ></frontend-dropdown-plain>
      </div>
    </div>
  </div>
</form>

<div modalFooter class="modal-footer">
  <button
    class="btn btn-info"
    type="submit"
    angularticsCategory="settings"
    angulartics2On="click"
    angularticsAction="Confirm Add/Edit Resource"
    [disabled]="resourceForm.pristine || !resourceForm.valid"
    (click)="confirm(resourceForm.value)"
  >Confirm</button>
  <button
    type="button"
    class="btn btn-danger"
    (click)="cancel()"
    angularticsCategory="waitlist"
    angulartics2On="click"
    angularticsAction="Cancel Add/Edit Resource"
  >Cancel</button>
</div>
